export const files = ({ data }: { data: any }): any => data;
